const ACTIVELY_REVIEWING_HOURS = 1;
const RECENTLY_ACTIVE_DAYS = 2;

export const CLIENT_ACTIVITY_LABELS = {
  actively_reviewing: 'Actively reviewing',
  recently_active: 'Recently active',
};

/**
 * Determines the client's activity status for display on project pages,
 * based solely on their last_active timestamp.
 *
 * Returns:
 * - 'actively_reviewing' if the client was active within the last hour
 * - 'recently_active' if the client was active within the last 2 days
 * - null if there has been no meaningful recent activity (status should be hidden)
 *
 * @param {Object} brief - The brief/job object (unused, kept for API consistency)
 * @param {Object} owner - The client/owner user object
 * @returns {string|null}
 */
export function getClientActivityStatus(brief, owner) {
  if (!owner || !owner.last_active) {
    return null;
  }

  const now = new Date();
  const lastActive = new Date(owner.last_active);
  const secondsSinceActive = (now - lastActive) / 1000;
  const hoursSinceActive = secondsSinceActive / 3600;

  if (hoursSinceActive <= ACTIVELY_REVIEWING_HOURS) {
    return 'actively_reviewing';
  }

  if (hoursSinceActive <= RECENTLY_ACTIVE_DAYS * 24) {
    return 'recently_active';
  }

  return null;
}

/**
 * Human-readable label for {@link getClientActivityStatus}, or null when hidden.
 *
 * @param {string|null} status
 * @returns {string|null}
 */
export function getClientActivityLabel(status) {
  if (!status) {
    return null;
  }

  return CLIENT_ACTIVITY_LABELS[status] || null;
}
